import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

const ShowOncePerUser  = ({ localStoregKey, children }) => {

    const { user } = useSelector(state => state.auth);
    const [showChildren, setShowChildren] = useState(false);
    const storageKey = `${localStoregKey}_${user?.exidentifier}`;


    useEffect(() => {
        const hasSeen = localStorage.getItem(storageKey);
        if (!hasSeen) {
            setShowChildren(true);
        }
    }, [storageKey]);

    const handleClose = () => {
        localStorage.setItem(storageKey, "true");
        setShowChildren(false);
    };

    return showChildren && React.cloneElement(children, { onClose: handleClose });
};

export default ShowOncePerUser ;
